<template>
	<b-row>
		<b-col cols="12" lg="8">
			<Overview />
		</b-col>
		<b-col cols="12" lg="4">
			<Remarks />
		</b-col>
	</b-row>
</template>

<script>
import Overview from '@/views/CustomerProfile/CenterComponents/Overview/Overview';
import Remarks from '@/views/CustomerProfile/CenterComponents/Overview/Remarks';

export default {
	components: {
		Overview,
		Remarks
	}
}
</script>